
import React, { useEffect } from 'react';
import PageLayout from '@/components/layout/PageLayout';
import { Bug, Lightbulb, Star } from 'lucide-react';

const ShareFeedback: React.FC = () => {
  useEffect(() => {
    // Load Tally embed script
    const script = document.createElement('script');
    script.innerHTML = `
      var d=document,w="https://tally.so/widgets/embed.js",v=function(){"undefined"!=typeof Tally?Tally.loadEmbeds():d.querySelectorAll("iframe[data-tally-src]:not([src])").forEach((function(e){e.src=e.dataset.tallySrc}))};if("undefined"!=typeof Tally)v();else if(d.querySelector('script[src="'+w+'"]')==null){var s=d.createElement("script");s.src=w,s.onload=v,s.onerror=v,d.body.appendChild(s);}
    `;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      document.body.removeChild(script);
    };
  }, []);

  return (
    <PageLayout 
      title="Share Your Feedback" 
      description="Help us improve Forkast with your suggestions and bug reports"
    >
      <div className="space-y-6 pb-14">
        {/* Main Feedback Content */}
        <div className="space-y-6">
          {/* Feedback Categories */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="flex items-start gap-3 p-4 bg-orange-50 rounded-lg border border-orange-200">
              <Bug className="h-6 w-6 text-orange-500 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-medium text-gray-900 mb-1">Report a Bug</h3>
                <p className="text-sm text-muted-foreground">
                  Found something that's not working as expected? Let us know!
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-4 bg-green-50 rounded-lg border border-green-200">
              <Lightbulb className="h-6 w-6 text-green-500 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-medium text-gray-900 mb-1">Feature Request</h3>
                <p className="text-sm text-muted-foreground">
                  Have an idea for a new feature? We'd love to hear it!
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-4 bg-purple-50 rounded-lg border border-purple-200">
              <Star className="h-6 w-6 text-purple-500 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-medium text-gray-900 mb-1">General Feedback</h3>
                <p className="text-sm text-muted-foreground">
                  Share your overall experience and suggestions for improvement.
                </p>
              </div>
            </div>
          </div>

          {/* Tally Embed */}
          <div className="mt-6">
            <iframe 
              data-tally-src="https://tally.so/embed/waqWQX?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" 
              loading="lazy" 
              width="100%" 
              height="699" 
              frameBorder="0" 
              marginHeight={0} 
              marginWidth={0}
              title="forkast.in: bugs & suggestions"
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "8px"
              }}
            />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default ShareFeedback;
